module.exports = __webpack_public_path__ + "img/seek.3e0cd344.svg";